import { render, staticRenderFns } from "./OxEditor.vue?vue&type=template&id=02919db4&"
import script from "./OxEditor.vue?vue&type=script&lang=js&"
export * from "./OxEditor.vue?vue&type=script&lang=js&"
import style0 from "./OxEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports